import RelatedPages from './related-pages';

export default class RelatedPagesDesktop extends RelatedPages {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/related-pages/related-pages.desktop.js